import ClientCard from './ClientCard';
import ClientCards from './ClientCards';
import ClientForm from './ClientForm';
import ClientsFilter from './ClientsFilter';

import {
  ClientDialog,
} from './Dialog';

export {
  ClientCard,
  ClientCards,
  ClientDialog,
  ClientForm,
  ClientsFilter,
};



// WEBPACK FOOTER //
// ./src/components/admin/Clients/index.js